/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TotalDischarges } from './totalDischarges';


export interface StatusCodeValueTotalDischarges { 
    value?: TotalDischarges;
    status_code?: number;
}

